import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const PubPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.Pub}
        fetchRecordsUrl={AdminReqUrls.admin__pub__mainPage_fetch_recordList}
    />)
});
export default PubPage;
